module.exports = __webpack_public_path__ + "img/tima_app.a79b6df3.png";